import { render, staticRenderFns } from "./SceneInfoPanel.vue?vue&type=template&id=7bed488b&scoped=true"
import script from "./SceneInfoPanel.vue?vue&type=script&lang=js"
export * from "./SceneInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./SceneInfoPanel.vue?vue&type=style&index=0&id=7bed488b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bed488b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cmdgame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bed488b')) {
      api.createRecord('7bed488b', component.options)
    } else {
      api.reload('7bed488b', component.options)
    }
    module.hot.accept("./SceneInfoPanel.vue?vue&type=template&id=7bed488b&scoped=true", function () {
      api.rerender('7bed488b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/SceneInfoPanel.vue"
export default component.exports